import * as Yup from 'yup';

// Common validation schema for all product types
const BaseProductSchema = {
  name: Yup.string().max(100).required('Required field').label('Name'),
  description: Yup.string()
    .max(300)
    .label('Description')
    .required('Required field'),
  price: Yup.number()
    .transform((value, originalValue) => 
      // Check if the value is empty or not a valid number
       originalValue === '' || isNaN(value) ? undefined : value
    )
    .typeError('Please enter a valid price')
    .min(0, 'Price must be 0 or higher')
    .max(999999, 'Price cannot exceed 999,999')
    .required('Please enter a price')
    .label('Price'),
  isPrivate: Yup.boolean().required('Required field'),
  isActive: Yup.boolean().required('Required field'),
  imageUrl: Yup.string(),
  startDate: Yup.string(),
  endDate: Yup.string()
};

export default BaseProductSchema;
